
export enum ENV {
  Local = 'local',
  Dev = 'dev',
  Prod = 'prod',
}
